import {
    FetchState,
} from "@/shared/types";
import {
    CampaignState,
    CampaignDataModel,
    CreateTransferOutCampaignRequest,
} from "../types";
import * as userService from "@/shared/api/userService";
import * as storeHelper from "@/shared/storeHelper";
import { defineStore } from "pinia";
import _ from "lodash";

export const defaultState: CampaignState = {
    FetchState: FetchState.Uninitialized,
    CampaignData: [],
    CurrentCampaign: null,
    campaignRetentionData: null
};

export const useTransferOutStore = defineStore("transferOut", {
    state: (): CampaignState => (_.cloneDeep(defaultState)),
    getters: {
        isLoaded: state => state.FetchState === FetchState.Loaded
    },
    actions: {
        setGetRequestFetchState (newFetchState: FetchState) {
            this.FetchState = newFetchState;
        },
        setCampaignData (response: CampaignDataModel[]) {
            this.CampaignData = response;
        },
        currentCampaignData (response: any) {
            this.CurrentCampaign = response.campaign;
            this.CurrentCampaign.employerId = response.employer.id;
            this.CurrentCampaign.employerExtId = response.employer.externalEmployerId;
            this.CurrentCampaign.employerName = response.employer.name;
        },
        setCampaignRetentionData (response: any) {
            this.campaignRetentionData = response;
        },
        getCampaigns () {
            return userService.getCampaigns().then(resp => {
                this.setCampaignData(resp.data);
                this.setGetRequestFetchState(FetchState.Loaded);
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        },
        createCampaign (campaign: CreateTransferOutCampaignRequest) {
            return userService.ebtoCreateCampaign(campaign).then(resp => {
                return resp;
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        },
        updateCampaign (campaign: CreateTransferOutCampaignRequest) {
            return userService.ebtoUpdateCampaign(campaign).then(resp => {
                return resp;
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        },
        getCampaignDetails (campaignKey: string) {

            return userService.getCampaignDetails(campaignKey).then(resp => {
                this.currentCampaignData(resp.data);
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        },
        getCampaignRetentionDetails (campaignKey: string) {

            return userService.getCampaignRetentionDetails(campaignKey).then(resp => {
                this.setCampaignRetentionData(resp.data);
            }).catch(err => {
                storeHelper.handleError({ error: err, rethrow: true });
            });
        }
    }
});